import { Container, Grid, Stepper, Step, StepLabel, Typography } from "@mui/material";
import { useContext } from "react";
import { createPortal } from "react-dom";
import { Global, css } from "@emotion/react";
import Page from "../../minimals/components/page";
import { useSettingsContext } from "../../minimals/components/settings";
import HeaderBreadcrumbs from "../components/HeaderBreadcrumbs";
import useResponsive from "../../minimals/hooks/useResponsive";
import { HeaderSlotContext } from "../components/layouts/dashboard/HeaderSlotContext";
// ----------------------------------------------------------------------

const STEPS = ["Order Information", "Order Searches", "Confirmation"];

type Prop = {
  title: string;
  activeStep: number;
  children: JSX.Element;
};

export default function OrderPageContainer(pageProps: Prop) {
  const { themeStretch } = useSettingsContext();
  const isMobile = useResponsive("down", "md");
  const { slotEl } = useContext(HeaderSlotContext);

  const { title, activeStep, children } = pageProps;

  return (
    <Page title={title} width="100%">
      {isMobile && (
        <Global
          styles={css`
            main {
              /* Mobile drops the breadcrumb block, which was supplying the clearance
                 under the fixed 64px header. */
              padding-top: 64px !important;
            }
          `}
        />
      )}

      {/* Same pattern as /calendar and the phonebook: the heading renders in the site
          header beside the nav button rather than costing a page row. */}
      {isMobile && slotEl
        ? createPortal(
            <Typography
              noWrap
              sx={{ color: "primary.dark", fontSize: 17, fontWeight: 700, lineHeight: 1.2, minWidth: 0 }}
            >
              Express Order Placement
            </Typography>,
            slotEl
          )
        : null}

      <Container maxWidth={themeStretch ? false : "lg"} sx={{ px: { xs: 1.5, md: 3 } }}>
        {!isMobile && (
          <HeaderBreadcrumbs
            heading="Express Order Placement"
            links={[{ name: "Orders", href: "" }, { name: "Express Order Placement", href: "" }, { name: "New Order" }]}
          />
        )}

        <Grid container spacing={{ xs: 0, md: 5 }}>
          <Grid item xs={12} md={8}>
            <Stepper
              alternativeLabel
              activeStep={activeStep}
              sx={{ marginBottom: 3 }}
            >
              {STEPS.map((label) => (
                <Step key={label}>
                  <StepLabel
                    sx={{
                      "& .MuiStepLabel-label": {
                        typography: "subtitle2",
                        color: "text.disabled",
                        // Three labels at subtitle2 don't fit 375px. Set after
                        // `typography`, which carries its own font size.
                        fontSize: { xs: 12, md: undefined }
                      }
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>
          <Grid item md={4} />
        </Grid>
        {children}
      </Container>
    </Page>
  );
}
